export default __webpack_public_path__ + "static/media/ratcode.b492608c.png";